import type { routes } from '@semios/app-platform-banyan-route-definitions'
import type { TEmitterType } from '@semios/app-platform-values-helpers-and-types'
import type { TIrrigationDeviceStatus, TValuesCurrentProperties } from 'App/Map/types'
import { getPressureReading } from './getPressureReading'
import { insertEmitterTypeForPressure } from './insertEmitterTypeForPressure'
import { insertEmitterTypeForStatus } from './insertEmitterTypeForStatus'
import { sortSelectedEmittersAndBestReadingsFirst } from './sortSelectedEmittersAndBestReadingsFirst'

type TPropertyValues = NonNullable<routes.ValuesCurrent.Response['properties']>[string]

type TStatusValueType = Extract<TValuesCurrentProperties, `irrigationIsOn_${string}_status`>

export const getPropertyPressureRow = ({
  nowMs,
  propertyValues,
  propertyValuesCurrent,
  selectedEmitters,
}: {
  nowMs: number
  propertyValues: TPropertyValues | undefined
  propertyValuesCurrent: string[]
  selectedEmitters: TEmitterType[]
}) => {
  const rows = selectedEmitters
    .filter((emitterType) => propertyValuesCurrent.includes(insertEmitterTypeForPressure(emitterType)))
    .map((emitterType) => {
      const reading = getPressureReading({
        entry: propertyValues?.[insertEmitterTypeForPressure(emitterType)],
        nowMs,
      })

      const status: TIrrigationDeviceStatus =
        propertyValues?.[insertEmitterTypeForStatus(emitterType) as TStatusValueType]?.value ?? 'unknown'

      return { emitterType, reading, status, isRunning: reading.state === 'LIVE' && status === 'on' }
    })

  const bestRow: (typeof rows)[number] | undefined = sortSelectedEmittersAndBestReadingsFirst(
    rows,
    selectedEmitters,
  )[0]

  return bestRow
}
